module.exports = __webpack_public_path__ + "img/image-9.5e6591d5.webp";